<template>
  <div class="min-h-screen">
    <div v-if="!showTeamMember">
      <div class="bg-white m-3 rounded-md">
        <div class="border-b-0.5 flex justify-between items-center p-3">
          <p class="text-sm font-semibold">
            Pending Leave Requests ({{ pendingLeaves.length }})
          </p>


          <router-link
              v-if="getUserType.toLowerCase() === 'hr manager'"
              :to="`/timeoff-setups/time-off-journals/#time-off-journals`"
              class="bg-primary text-white rounded-full px-4 py-2 text-sm"
          >
            Request Leave on Behalf
          </router-link>

          <!--          <button
                      v-if="getUserType.toLowerCase() === 'hr manager'"
                      @click="showCreateTimeoffJournal = true"
                      class="bg-primary text-white rounded-full px-3 py-1 text-sm"
                    >
                      Request Leave on Behalf
                    </button>-->
        </div>
        <!-- {{ pendingLeaves.length }} -->
        <div class="relative" style="min-height: 10rem">
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <div class="" v-if="pendingLeaves.length">
            <div class="flex items-left my-2 mb-3">
              <el-pagination
                background
                @size-change="handleSizeChange"
                :page-sizes="pageSizes"
                :page-index="pageIndex"
                :page-size="pageSize"
                layout="sizes"
                :total="totalCount()"
              >
              </el-pagination>

              <!-- search -->
              <input
                v-model="searchInputForPendingLeaves"
                type="search"
                placeholder="Start typing to search..."
                class="bg-gray-200 w-52 py-2 rounded-md"
              />
              <!-- search -->
            </div>

            <div>
              <ve-table
                v-if="searchInputForPendingLeaves"
                :columns="columns"
                :table-data="filteredPendingLeavesTableData"
                sort-order="asc"
                :expand-option="expandOption"
                row-key-field-name="Id"
              />

              <ve-table
                :columns="columns"
                :tableData="filteredPendingLeavesTableData"
                v-if="!searchInputForPendingLeaves.length"
                :expand-option="expandOption"
                row-key-field-name="Id"
              >
              </ve-table>

              <p
                v-if="
                  searchInputForPendingLeaves.length &&
                  filteredPendingLeavesTableData.length === 0
                "
                class="text-center py-3"
              >
                No results
              </p>

              <p
                v-if="filteredPendingLeavesTableData.length == 0 && !loading"
                class="p-1 text-center text-sm w-full bg-gray-100"
              >
                <el-empty :image-size="70" description="No leaves"></el-empty>
              </p>
            </div>
          </div>
          <div
            v-if="!loading && filteredPendingLeavesTableData.length === 0"
            class="flex flex-col justify-center items-center h-full mt-5"
          >
            <el-empty
              :image-size="70"
              description="No Leave Requests"
            ></el-empty>
          </div>
        </div>
        <!-- Pagination -->
        <div class="table-pagination text-center mt-2">
          <el-pagination
            v-if="filteredPendingLeavesTableData?.length > 0"
            background
            layout="prev, pager, next"
            :total="totalCount()"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">
          Leave History ({{ filteredLeaveHistories.length }})
        </p>
      </div>

      <div class="">
        <!-- @tab-click="(e) => setTab(e)" -->
        <el-tabs type="border-card" v-model="currentTab">
          <el-tab-pane
            v-for="(tab, index) in filteredTabs"
            :key="index"
            :label="tab.name"
            :name="tab.name"
          >
            <div class="" v-if="filteredLeaveHistories.length && !loading">
              <div class="flex items-left my-2 mb-3">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  :page-sizes="pageSizes"
                  :page-index="pageIndex"
                  :page-size="pageSize"
                  layout="sizes"
                  :total="pendingLeaves.length"
                >
                  <!--   :total="filteredLeaveHistoriesTableData.length" -->
                </el-pagination>

                <!-- search -->
                <input
                  v-model="searchInputForLeaveHistories"
                  type="search"
                  placeholder="Start typing to search..."
                  class="bg-gray-200 w-52 py-1 rounded-md"
                />
                <!-- search -->
              </div>

              <div>
                <ve-table
                  v-if="searchInputForLeaveHistories"
                  :columns="
                    currentTab === 'Active'
                      ? activeColumns
                      : currentTab !== 'Handover Notes'
                      ? columns.slice(0, -2)
                      : handoverNotesColumns
                  "
                  :table-data="filteredLeaveHistoriesTableData"
                  sort-order="asc"
                />

                <ve-table
                  :fixed-header="true"
                  :max-height="500"
                  :columns="
                    currentTab === 'Active'
                      ? activeColumns
                      : currentTab !== 'Handover Notes'
                      ? columns.slice(0, -2)
                      : handoverNotesColumns
                  "
                  :tableData="filteredLeaveHistoriesTableData"
                  :virtual-scroll-option="virtualScrollOption"
                  row-key-field-name="Id"
                  v-if="!searchInputForLeaveHistories.length"
                >
                </ve-table>

                <p
                  v-if="
                    searchInputForLeaveHistories.length &&
                    filteredTableData2.length === 0
                  "
                  class="text-center py-3"
                >
                  No results
                </p>
              </div>
            </div>
            <p v-else class="text-center p-3 text-sm w-full bg-gray-100">
              <el-empty
                :image-size="70"
                description="No Leaves found"
              ></el-empty>
            </p>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div v-if="showTeamMember">
      <team-member @backToTeam="showTeamMember = false"></team-member>
    </div>
    <leave-decline-reason
      :showAddReason="showAddReason"
      :setReason="setReason"
      @close="handleClose"
    >
    </leave-decline-reason>

    <approval-warning
      :show-approval-warning="showApprovalWarning"
      :setIsConfirmed="setIsConfirmed"
      @close="showApprovalWarning = false"
    >
    </approval-warning>

    <review-leave
      :show-review-leave="showReviewLeave"
      @close="showReviewLeave = false"
      :approvalEntries="approvalEntries"
      :leaveDetails="leaveDetails"
      :attachmentUrl="attachmentUrl"
    ></review-leave>
    <recall-modal
      :show-recall-modal="showRecallModal"
      @close="showRecallModal = false"
      :leaveDetails="leaveDetails"
      :setIsConfirmed="setIsConfirmed"
    ></recall-modal>
    <CreateTimeoffJournal
      @close="handleCloseBookLeave"
      :showCreateTimeoffJournal="showCreateTimeoffJournal"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
      :title="modalTitle"
    ></CreateTimeoffJournal>

    <el-drawer
      title="Handover Notes"
      :visible.sync="isDrawerOpen"
      :direction="direction"
      :size="isSmallScreen ? '100%' : '30%'"
    >
      <RichTextEditor :info="notes" @content-changed="handleContentChanged" />
    </el-drawer>
  </div>
</template>

<script>
import axios from 'axios';
import TeamMember from './teamMember.vue';
import LeaveDeclineReason from './addReason.vue';
import ApprovalWarning from './approvalWarning.vue';

import ReviewLeave from './reviewLeave.vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import Loader from '@/components/loader/loader.vue';
import decryptData from '@/utils/decrypt';
import CreateTimeoffJournal from '@/components/CompanySetups/timeOffSetups/create';
import RecallModal from '@/components/timeoff/recallModal';

export default {
  name: 'TeamTimeOff',

  components: {
    TeamMember,
    LeaveDeclineReason,
    ReviewLeave,
    ApprovalWarning,
    Loader,
    CreateTimeoffJournal,
    RecallModal,
  },
  data() {
    return {
      isSmallScreen: false,
      showCreateTimeoffJournal: false,
      notes: null,
      isDrawerOpen: false,
      direction: 'rtl',
      modalTitle: 'Request Leave on Behalf',
      startRowIndex: 0,
      virtualScrollOption: {
        enable: true,
        scrolling: this.scrolling,
      },
      tableData: [],
      canceledLeaves: [],
      declinedLeaves: [],
      pendingLeaves: [],
      approvedLeaves: [],
      filteredLeaveHistories: [],
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      RowId: null,
      showLeaveApplicationModal: false,
      approval: [],
      leaveApplication: {
        pdfUrl: 'https://www.africau.edu/images/default/sample.pdf',
        docUrl: 'https://example.com/myfile.docx',
        images: [
          'https://example.com/image1.jpg',
          'https://example.com/image2.jpg',
        ],
      },
      showAttachments: false,
      attachmentUrl: '',
      showRequestLeave: false,
      reason: null,
      message: null,
      showTeamMember: false,
      isDeclined: false,
      isConfirmed: false,
      showAddReason: false,
      approvalEntries: null,
      leaveDetails: null,
      showReviewLeave: false,
      showApprovalWarning: false,
      rowToApprove: null,
      searchInputForPendingLeaves: '',
      searchInputForLeaveHistories: '',
      selectedTab: 'Approved',
      teamKey: 0,
      mineKey: 1,
      get_error: null,
      loading: false,
      cancelledAndDeclinedLeaves: [],
      filteredTableData2: [],
      showRecallModal: false,

      tabs: [
        {
          name: 'Approved',
          route: 'team-approved',
        },
        {
          name: 'Active',
          route: 'active-leave',
        },
        {
          name: 'Declined',
          route: 'team-declined',
        },
        {
          name: 'Canceled',
          route: 'team-canceled',
        },
        {
          name: 'Handover Notes',
          route: 'handover-notes',
        },
      ],

      currentTab: 'Approved',
      columns: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 10,
          align: 'left',
          headerAlign: 'left',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: 'Name',
          key: 'Name',
          title: 'Name',
          align: 'left',
          width: '15%',
          renderBodyCell: ({ row }) => {
            return decryptData(row.Name, this.$decryptionKey);
          },
        },
        {
          field: 'LeaveType',
          key: 'LeaveType',
          title: 'Type',
          align: 'left',
          headerAlign: 'left',
        },
        {
          field: 'StartDate',
          key: 'StartDate',
          title: 'From',
          align: 'left',
          headerAlign: 'left',
          width: 160,
          renderBodyCell: ({ row }) =>
            moment(row.StartDate).format('DD/MM/YYYY'),
        },
        {
          field: 'EndDate',
          key: 'EndDate',
          title: 'To',
          align: 'left',
          headerAlign: 'left',
          width: 160,
          renderBodyCell: ({ row }) => moment(row.EndDate).format('DD/MM/YYYY'),
        },
        { field: 'Period', key: 'c', title: 'Days' },

        {
          field: 'Description',
          key: 'Description',
          title: 'Description',
          align: 'left',
          headerAlign: 'left',
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement='top-start'
              title={
                'Leave request from ' +
                decryptData(row.Name, this.$decryptionKey)
              }
              width='300'
              trigger='hover'
              content={row.Description}
            >
              <p
                slot='reference'
                class='cursor-pointer'
                styel='font-size: 0.68rem !important;'
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },
        // Declined

        {
          field: 'Status',
          key: 'Status',
          title: 'Status',
          renderBodyCell: ({ row }) => {
            let status = '';
            switch (row.Status) {
              case 'Approved':
                status = (
                  <p class='cursor-pointer text-green-500'> {row.Status}</p>
                );
                break;

              case 'Pending':
                status = (
                  <p
                    class='p-0 m-0 text-center cursor-pointer text-blue-500'
                    v-if={row.Status === 'Pending'}
                  >
                    {row.Status}
                  </p>
                );
                break;
              case 'Declined':
                status = (
                  <p
                    class='text-center cursor-pointer text-red-500'
                    v-if={row.Status === 'Declined'}
                  >
                    {row.Status}
                  </p>
                );
                break;
              case 'Canceled':
                status = (
                  <p
                    class='text-center cursor-pointer text-red-500'
                    v-if={row.Status === 'Canceled'}
                  >
                    {row.Status}
                  </p>
                );
                break;
            }
            return <p>{status}</p>;
          },
        },
        {
          field: '',
          key: 'action',
          title: 'Action',
          align: 'center',
          headerAlign: 'center',
          renderBodyCell: ({ row, rowIndex }) => {
            if (row.Status === 'Approved' || row.Status === 'Declined') {
              return null; // Hide the column if the leave is approved or declined
            } else {
              return (
                <ve-popper
                  trigger='clickToOpen'
                  options={{
                    placement: 'top',
                    modifiers: { offset: { offset: '30px,10px' } },
                  }}
                >
                  <div class='bg-white p-2 shadow-md popper'>
                    <button
                      class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                      style='boder-radius: 0 !important'
                      on-click={() => {
                        this.rowToApprove = row;
                        this.showApprovalWarning = true;
                      }}
                    >
                      Approve
                    </button>
                    <button
                      class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                      style='boder-radius: 0 !important'
                      on-click={() => this.declineLeave(row)}
                    >
                      Decline
                    </button>
                    <button
                      class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                      style='boder-radius: 0 !important'
                      on-click={() => this.setNotes(rowIndex)}
                    >
                      View Notes
                    </button>
                  </div>

                  <button slot='reference' class='m-0 p-0'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      id='Outline'
                      viewBox='0 0 24 24'
                      width='20'
                      height='20'
                    >
                      <circle cx='12' cy='2' r='2' />
                      <circle cx='12' cy='12' r='2' />
                      <circle cx='12' cy='22' r='2' />
                    </svg>
                  </button>
                </ve-popper>
              );
            }
          },
        },

        {
          field: '',
          key: 'expand',
          type: 'expand',
          title: '',
          width: 50,
          align: 'center',
        },
      ],
      activeColumns: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 10,
          align: 'left',
          headerAlign: 'left',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: 'Name',
          key: 'Name',
          title: 'Name',
          align: 'left',
          width: '15%',
          renderBodyCell: ({ row }) => {
            return decryptData(row.Name, this.$decryptionKey);
          },
        },
        {
          field: 'LeaveType',
          key: 'LeaveType',
          title: 'Type',
          align: 'left',
          headerAlign: 'left',
        },
        {
          field: 'StartDate',
          key: 'StartDate',
          title: 'From',
          align: 'left',
          headerAlign: 'left',
          width: 160,
          renderBodyCell: ({ row }) =>
            moment(row.StartDate).format('DD/MM/YYYY'),
        },
        {
          field: 'EndDate',
          key: 'EndDate',
          title: 'To',
          align: 'left',
          headerAlign: 'left',
          width: 160,
          renderBodyCell: ({ row }) => moment(row.EndDate).format('DD/MM/YYYY'),
        },
        { field: 'Period', key: 'c', title: 'Days' },

        {
          field: 'Description',
          key: 'Description',
          title: 'Description',
          align: 'left',
          headerAlign: 'left',
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement='top-start'
              title={
                'Leave request from ' +
                decryptData(row.Name, this.$decryptionKey)
              }
              width='300'
              trigger='hover'
              content={row.Description}
            >
              <p
                slot='reference'
                class='cursor-pointer'
                styel='font-size: 0.68rem !important;'
              >
                {row.Description}
              </p>
            </el-popover>
          ),
        },
        {
          field: '',
          key: 'action',
          title: 'Action',
          align: 'center',
          headerAlign: 'center',
          renderBodyCell: ({ row }) => {
            return (
              <ve-popper
                trigger='clickToOpen'
                options={{
                  placement: 'top',
                  modifiers: { offset: { offset: '0,10px' } },
                }}
              >
                <div class='bg-white p-2 shadow-md popper'>
                  <button
                    class='w-full text-left py-1 px-2 hover:bg-primary hover:text-white'
                    style='boder-radius: 0 !important'
                    on-click={() => {
                      this.leaveDetails = row;
                      this.showRecallModal = true;
                    }}
                  >
                    Recall
                  </button>
                </div>

                <button slot='reference' class='m-0 p-0'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    id='Outline'
                    viewBox='0 0 24 24'
                    width='20'
                    height='20'
                  >
                    <circle cx='12' cy='2' r='2' />
                    <circle cx='12' cy='12' r='2' />
                    <circle cx='12' cy='22' r='2' />
                  </svg>
                </button>
              </ve-popper>
            );
          },
        },

        {
          field: '',
          key: 'expand',
          type: 'expand',
          title: '',
          width: 50,
          align: 'center',
        },
      ],
      columns2: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 10,
          align: 'center',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: 'Name',
          key: 'Name',
          title: 'Name',
          align: 'left',
          width: '15%',
          renderBodyCell: ({ row }) => {
            return (
              <div
                on-click={() => {
                  this.attachmentUrl = row.Attachment;
                  this.approvalEntries = row.ApprovalEntries;
                  this.leaveDetails = row;
                  this.showReviewLeave = true;
                  this.showAttachments = true;
                }}
                class='flex gap-5 items-center'
              >
                <div class='h-8 w-8 rounded-full'>
                  <img
                    class='h-full w-full rounded-full'
                    src='https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png'
                  />
                </div>
                <p class='text-blue-500 cursor-pointer'>{row.Name}</p>
              </div>
            );
          },
        },
        {
          field: 'LeaveType',
          key: 'LeaveType',
          title: 'Type',
          align: 'left',
          headerAlign: 'left',
        },
        {
          field: 'StartDate',
          key: 'StartDate',
          title: 'From',
          align: 'left',
          headerAlign: 'left',
          renderBodyCell: ({ row }) => (
            <p class='text-left'>{this.formatDate(row.EndDate)}</p>
          ),
          ellipsis: {
            showTitle: true,
          },
        },
        {
          field: 'To',
          key: 'To',
          title: 'To',
          align: 'left',
          headerAlign: 'left',
          renderBodyCell: ({ row }) => (
            <p class='text-left'>{this.formatDate(row.EndDate)}</p>
          ),
          ellipsis: {
            showTitle: true,
          },
        },
        { field: 'Period', key: 'c', title: 'Days' },

        {
          field: 'Description',
          key: 'Description',
          title: 'Description',
          align: 'left',
          headerAlign: 'left',
        },
      ],

      approversColumns: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 10,
          align: 'center',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: 'Approver',
          key: 'Approver',
          title: 'Approver',
          align: 'left',
          headerAlign: 'left',
          renderBodyCell: ({ row }) => {
            return decryptData(row.Approver, this.$decryptionKey);
          },
        },
        {
          field: 'Sequence',
          key: 'Sequence',
          title: 'Sequence',
          align: 'center',
          headerAlign: 'center',
        },
        {
          field: 'ProcessedDate',
          key: 'DateProcessed',
          title: 'Date Processed',
          align: 'left',
          headerAlign: 'left',
          renderBodyCell: ({ row }) => {
            return row.ProcessedDate
              ? moment(row.ProcessedDate).format('DD/MM/YYYY')
              : '';
          },
        },
        {
          field: 'Status',
          key: 'Status',
          title: 'Status',
          align: 'left',
          headerAlign: 'left',
        },
        {
          field: 'Reason',
          key: 'Reason',
          title: 'Reason',
          align: 'left',
          headerAlign: 'left',
        },
      ],

      expandOption: {
        render: ({ row, column, rowIndex }, h) => {
          // this.selectedRow = row;
          row, column, rowIndex, h;
          const { ApprovalEntries } = row;

          return (
            <div class='my-2'>
              <div class='border-b-0.5 flex justify-between items-left pb-2'>
                <p class='text-sm font-semibold w-full'>Leave Approvers</p>
              </div>
              <ve-table
                columns={this.approversColumns}
                table-data={ApprovalEntries}
                sort-order='asc'
                row-key-field-name='SubDepartmentId'
              />
              {ApprovalEntries.length === 0 ? (
                <p class='p-1 text-center text-sm w-full bg-gray-100 text-center'>
                  No approvers found for{' '}
                  {decryptData(row.Name, this.$decryptionKey)}
                </p>
              ) : null}
            </div>
          );
        },
      },

      handoverNotesColumns: [
        {
          field: '',
          key: 'numbering',
          title: '#',
          width: 50,
          headerAlign: 'left',
          align: 'left',
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: 'SubmittedBy',
          key: 'SubmittedBy',
          title: 'Submitted By',
          headerAlign: 'left',
          align: 'left',
        },

        {
          field: 'ApprovedBy',
          key: 'ApprovedBy',
          title: 'Approved By',
          headerAlign: 'left',
          align: 'left',
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => (
            <el-popover
              placement='top-start'
              title={'Approved By'}
              width='300'
              trigger='hover'
            >
              <ul class='cursor-pointer' style='font-size: 0.68rem !important;'>
                {row.ApprovedBy.map((item, index) => (
                  <li key={index} class='flex items-center my-3'>
                    <el-avatar
                      size='small'
                      src={item.AvatarURL}
                      style='margin-right: 8px;'
                    ></el-avatar>
                    <span>{item.Name}</span>
                  </li>
                ))}
              </ul>
              <template slot='reference'>
                <ul
                  class='cursor-pointer'
                  style='font-size: 0.68rem !important;'
                >
                  {row.ApprovedBy.map((item, index) => (
                    <li key={index} class=' items-center'>
                      <span>{item.Name}</span>
                    </li>
                  ))}
                </ul>
              </template>
            </el-popover>
          ),
        },

        {
          field: 'LeaveType',
          key: 'x',
          title: 'Leave Type',
          headerAlign: 'left',
          align: 'left',
        },

        {
          field: 'Attachment',
          key: 'Notes',
          title: 'Notes',
          renderBodyCell: ({ rowIndex }) => {
            return (
              <button
                onClick={() => {
                  this.isDrawerOpen = true;
                  this.setNotes(rowIndex);
                }}
                class='bg-primary text-white rounded-full px-3 py-1 text-sm'
              >
                View
              </button>
            );
          },
        },
      ],

      handoverNotesData: [],
      activeLeaveData: [],
    };
  },

  computed: {
    ...mapGetters(['getOrganization', 'getToken', 'getUserType']),
    filteredTabs() {
      if (this.getUserType.toLowerCase() === 'hr manager') {
        return this.tabs;
      } else {
        return this.tabs.filter((tab) => tab.name.trim() !== 'Active');
      }
    },
    filteredPendingLeavesTableData() {
      if (!this.searchInputForPendingLeaves) {
        // If no search input is provided, return the full tableData
        return this.filteredPendingLeavesCurrentTableData();
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInputForPendingLeaves.toLowerCase();
        return this.filteredPendingLeavesCurrentTableData().filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },

    filteredLeaveHistoriesTableData() {
      if (!this.searchInputForLeaveHistories) {
        // If no search input is provided, return the full tableData
        return this.filteredLeaveHistoriesCurrentTableData();
      } else {
        // Filter the tableData based on the search input
        const searchInputLower =
          this.searchInputForLeaveHistories.toLowerCase();
        return this.filteredLeaveHistoriesCurrentTableData().filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    filteredColumns() {
      const approvedCount = this.leaves.filter(
        (leave) => leave.Status === 'Approved'
      ).length;
      const declinedCount = this.leaves.filter(
        (leave) => leave.Status === 'Declined'
      ).length;

      return this.columns.filter((column) => {
        if (
          column.field === 'Action' &&
          (approvedCount === this.leaves.length ||
            declinedCount === this.leaves.length)
        ) {
          return false;
        }
        return true;
      });
    },
  },
  mounted() {
    // Check screen size on component mount
    this.checkScreenSize();
    // Listen for resize events to dynamically update screen size
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    // Remove resize event listener on component destroy
    window.removeEventListener('resize', this.checkScreenSize);
  },
  created() {
    this.getTeamLeaves(this.currentTab);
    this.setPageSizes();
    // this.setTab();
  },
  watch: {
    currentTab: {
      handler(newVal) {
        this.getTeamLeaves(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    checkScreenSize() {
      // Determine screen size based on window width
      this.isSmallScreen = window.innerWidth <= 768; // Adjust 768 according to your breakpoint
    },
    // virtual scrolling
    scrolling({ startRowIndex }) {
      this.startRowIndex = startRowIndex;
    },
    // render row index
    renderRowIndex({ rowIndex }) {
      return (
        <span class='text-bold' style='color:#1890ff;'>
          {rowIndex + this.startRowIndex + 1}
        </span>
      );
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleFilteredLeaveHistoriesCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    setTab(event) {
      let id = event ? event['$el'].id : 'pane-0';

      switch (id) {
        case 'pane-0':
          this.selectedTab = 'Approved';
          this.updateLeaveList('Approved');
          break;
        case 'pane-1':
          this.selectedTab = 'Declined';
          this.updateLeaveList('Declined');
          break;
        case 'pane-2':
          this.selectedTab = 'Canceled';
          this.updateLeaveList('Canceled');
          break;
        case 'pane-3':
          this.selectedTab = 'Handover Notes';
          this.filteredLeaveHistories = this.handoverNotesData;
          break;
        case 'pane-4':
          this.selectedTab = 'Active';
          this.updateLeaveList('Active');
          break;
      }
    },
    setIsConfirmed() {
      this.loading = true;
      this.isConfirmed = true;
      this.approveLeave(this.rowToApprove);
      this.getTeamLeaves();
    },
    showLeaveApplication() {
      if (this.showLeaveApplicationModal) {
        this.showLeaveApplicationModal = false;
      } else {
        this.showLeaveApplicationModal = true;
      }
    },
    closeLeaveApplicationModal() {
      this.showLeaveApplicationModal = false;
    },

    viewTeamMember() {
      this.showTeamMember = true;
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      };
      return date.toLocaleDateString('en-US', options);
    },
    setReason(reason) {
      const data = {
        Id: this.RowId,
        Reason: reason,
        Status: 'Declined',
      };
      this.submit(data);
    },
    handleCloseOnSuccess() {
      this.showCreateTimeoffJournal = false;
      this.showLocCrSuccess = false;
      this.showEditJournal = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getTeamLeaves();
    },
    reload() {
      this.getTeamLeaves();
    },
    getTeamLeaves() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: '*/*',
        },
      };

      axios
        .get(
          `${this.getOrganization}/timeoff/myteam/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.status === 200) {
              this.$emit('closeOnSuccess');

              // Create a Set to store unique IDs
              const uniqueIds = new Set();

              // Filter the data array to retain only unique IDs
              const filteredData = response.data.Data.filter((item) => {
                if (!uniqueIds.has(item.Id)) {
                  uniqueIds.add(item.Id);
                  return true;
                }
                return false;
              });
              // Sort the filtered data by StartDate
              const sortedData = filteredData.sort(
                (a, b) => new Date(a.StartDate) < new Date(b.StartDate)
              );
              this.handoverNotesData = sortedData.map((d) => {
                return {
                  SubmittedBy: decryptData(d.Name, this.$decryptionKey),
                  // AssignedTo: [{ Name: "....." }, { Name: "....." }],
                  ApprovedBy: d.ApprovalEntries.map((a) => {
                    return {
                      Name: decryptData(a.Approver, this.$decryptionKey),
                    };
                  }),
                  DateApproved: '.....',
                  LeaveType: d.LeaveType,
                  LeaveAttachment: {
                    Attachment: d.Attachment,
                    ApprovalEntries: d.ApprovalEntries,
                  },
                  handoverNotes: d.HandoverNotes,
                };
              });

              this.pendingLeaves = sortedData.filter(
                (timeoff) => timeoff.Status === 'Pending'
              );

              this.approvedLeaves = filteredData.filter(
                (timeoff) => timeoff.Status === 'Approved'
              );

              this.canceledLeaves = sortedData.filter(
                (timeoff) => timeoff.Status === 'Canceled'
              );

              this.declinedLeaves = sortedData.filter(
                (timeoff) => timeoff.Status === 'Declined'
              );
              this.updateLeaveList(this.currentTab);
            } else {
              this.get_error = response.sortedData.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
      axios
        .get(
          `${this.getOrganization}/timeoff/active/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            if (response.status === 200) {
              this.activeLeaveData = response.data.Data;
            }
          },
          (error) => {
            this.get_error = error.message;
          }
        );
    },

    approveLeave({ Id, Reason }) {
      this.loading = true;
      const data = {
        Id,
        Reason: Reason,
        Status: 'Approved',
      };
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      this.showApprovalWarning = false;
      axios
        .post(
          `${this.getOrganization}/timeoff/${this.$ApiVersion}/process`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            if (response.data.StatusCode == 200) {
              this.$emit('closeOnSuccess');
              this.getTeamLeaves();

              this.tableData = response.data.Data;

              this.$notify.success({
                title: 'Success',
                message: response.data.StatusMessage,
              });
            } else {
              this.getTeamLeaves();

              this.$notify.error({
                title: 'Failure',
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 3000);
          }
        );
    },

    declineLeave({ Id }) {
      this.showAddReason = true;
      this.loading = true;
      this.RowId = Id;
    },

    submit(data) {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      // alert(this.getOrganization);
      if (data.Reason) {
        this.loading = true;
        this.showAddReason = false;
        axios
          .post(
            `${this.getOrganization}/timeoff/${this.$ApiVersion}/process`,
            JSON.stringify(data),
            options
          )
          .then(
            (response) => {
              this.loading = false;
              if (response.status == 200) {
                this.$emit('closeOnSuccess');
                this.getTeamLeaves();
                this.tableData = response.data.Data;
                this.$notify.success({
                  title: 'Success',
                  message: response.data.StatusMessage,
                });
              } else {
                this.getTeamLeaves();
                this.$notify.error({
                  title: 'Failure',
                  message: response.data.StatusMessage,
                });
              }
            },
            (error) => {
              this.loading = false;
              this.$notify.error({
                title: 'Failure',
                message: error.message,
              });
            }
          );
      } else {
        this.$notify.error({
          title: 'Failure',
          message: 'Reason for declination missing',
        });
      }
    },

    handleClose() {
      this.showAddReason = false;
      this.showApprovalWarning = false;
    },
    handleCloseBookLeave() {
      this.showCreateTimeoffJournal = false;
    },
    async updateLeaveList(currentTab) {
      this.currentTab = currentTab;
      switch (currentTab) {
        case 'Approved':
          this.filteredLeaveHistories = this.approvedLeaves;
          break;
        case 'Pending':
          this.filteredLeaveHistories = this.pendingLeaves;
          break;

        case 'Canceled':
          this.filteredLeaveHistories = this.canceledLeaves;
          break;
        case 'Declined':
          this.filteredLeaveHistories = this.declinedLeaves;
          break;
        case 'Handover Notes':
          this.filteredLeaveHistories = this.handoverNotesData;
          break;
        case 'Active':
          this.filteredLeaveHistories = this.activeLeaveData;
          break;
        default:
          break;
      }
    },
    // table data
    filteredLeaveHistoriesCurrentTableData() {
      // const { pageIndex, pageSize } = this;
      return this.filteredLeaveHistories;
    },

    filteredPendingLeavesCurrentTableData() {
      const { pageIndex, pageSize } = this;
      return this.pendingLeaves.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.pendingLeaves.length;
    },

    setNotes(rowIndex) {
      // let pendingLeavesData = this.handoverNotesData.filter(
      //   (l) => l.DateApproved === '.....'
      // );
      // console.log(this.pendingLeaves);
      if (!this.isDrawerOpen) {
        this.isDrawerOpen = true;
      }

      this.notes = this.pendingLeaves[rowIndex]?.HandoverNotes
        ? this.pendingLeaves[rowIndex]?.HandoverNotes
        : `<div class="flex flex-col justify-center items-center h-full mt-5">
           <h1>No handover notes found</h1>
         </div>`;
    },
  },
};
</script>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
.ve-table .ve-table-container .ve-table-content-wrapper {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  min-height: 50vh !important;
}
.el-drawer .p-2 h1 {
  font-size: 2rem; /* Adjust size */
  margin-bottom: 1rem; /* Adjust spacing */
}

.el-drawer .p-2 p {
  margin-bottom: 1rem; /* Add space between paragraphs */
}

.el-drawer .p-2 ul {
  padding-left: 1.5rem; /* Add left padding for lists */
}

.el-drawer .p-2 li {
  list-style-type: disc; /* Bullet points */
  margin-left: 1rem;
}
</style>
